import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { ToastrModule } from 'ngx-toastr';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AlertModule } from './shared/components/alert';
import { NgImageSliderModule } from 'ng-image-slider';

import { AppComponent } from './app.component';
import { ShopComponent } from './shop/shop.component';
import { PagesComponent } from './pages/pages.component';
import { ElementsComponent } from './elements/elements.component';
import { PopoverModule } from 'ngx-smart-popover';
import { NgOtpInputModule } from 'ng-otp-input';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { WINDOW_PROVIDERS } from './shared/services/window.providers';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
// import { ThermalPrintModule } from 'ng-thermal-print'; //add this line
import { LandscreenComponent } from './landscreen/landscreen.component';
import { MatTabsModule } from '@angular/material/tabs';
import { AuthConfig, AuthModule } from '@auth0/auth0-angular';
import { domain, clientId, callbackUri } from './auth.config';
import { CommonModule } from '@angular/common';
import { NgQrScannerModule } from 'ngx-qr';
// import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { NaviFreshMartService } from 'src/app/shared/services/navi-fresh-mart.service';
import { AngularFireModule } from '@angular/fire';
import { NewlandscreenComponent } from './newlandscreen/newlandscreen.component';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NqrmgmNavigaionComponent } from './nqrmgm-navigaion/nqrmgm-navigaion.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
export function initializeApp(navifreshmartService: NaviFreshMartService) {
  return () => navifreshmartService.loadConfig();
}
const config: AuthConfig = {
  domain,
  clientId,
  authorizationParams: {
    redirect_uri: callbackUri,
  },
  // For using Auth0-Angular with Ionic on Android and iOS,
  // it's important to use refresh tokens without the falback
  useRefreshTokens: true,
  cacheLocation: 'localstorage'
};

@NgModule({
  declarations: [
    AppComponent,
    ShopComponent,
    PagesComponent,
    ElementsComponent,
    LandscreenComponent,
    NewlandscreenComponent,
    NqrmgmNavigaionComponent
  ],
  imports: [
    CommonModule,
    AlertModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    HttpClientModule,
    NgbModule,
    LoadingBarHttpClientModule,
    LoadingBarRouterModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      progressBar: false,
      enableHtml: true,
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    SharedModule,
    AppRoutingModule,
    PopoverModule,
    NgOtpInputModule,
    NgImageSliderModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    MatTabsModule,
    AuthModule.forRoot(config),

    NgQrScannerModule,
    // ZXingScannerModule,
    AngularFireModule.initializeApp(environment.FirebaseConfig),
    MatButtonModule,
    MatIconModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatBottomSheetModule

  ],
  providers: [
    NgbActiveModal,
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill' } },
    { provide: LocationStrategy, useClass: HashLocationStrategy },

    WINDOW_PROVIDERS
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
